import axios from "axios";
import { tokenManager } from "utils/tokenManager";

const KPI_API_BASE = "https://usibras-web-backend.onrender.com/api";

/**
 * Fetch all training topics.
 *
 * @returns {Promise<{ data: Array<{ id, name, definition, sector_name, start_date, created_at, updated_at }>, message: string }>}
 */
export async function getTrainingTopics() {
  const authHeader = tokenManager.getAuthHeader();
  const headers = {};
  if (authHeader) {
    headers.Authorization = authHeader;
  }
  const response = await axios.get(`${KPI_API_BASE}/training-topics`, { headers });
  return response.data;
}

/**
 * Fetch training topics by sector.
 *
 * @param {string} sectorName - Sector name (e.g. "Production", "Raw Nut")
 * @returns {Promise<{ data: Array<{ id, name, definition, sector_name, start_date, created_at, updated_at }>, message: string }>}
 */
export async function getTrainingTopicsBySector(sectorName) {
  const authHeader = tokenManager.getAuthHeader();
  const headers = {};
  if (authHeader) {
    headers.Authorization = authHeader;
  }
  const params = sectorName ? { sector_name: sectorName } : {};
  const response = await axios.get(`${KPI_API_BASE}/training-topics`, { headers, params });
  return response.data;
}

/**
 * Create a training topic.
 *
 * @param {Object} data
 * @param {string} data.sector_name - Sector name
 * @param {string} data.name - Topic name
 * @param {string} [data.definition] - Topic definition
 * @param {string} [data.start_date] - Start date (YYYY-MM-DD)
 * @returns {Promise<{ data: Object, message: string }>}
 */
export async function createTrainingTopic(data) {
  const authHeader = tokenManager.getAuthHeader();
  const headers = {};
  if (authHeader) {
    headers.Authorization = authHeader;
  }
  const response = await axios.post(
    `${KPI_API_BASE}/training-topics`,
    {
      sector_name: data.sector_name?.trim() || "",
      name: data.name?.trim() || "",
      definition: data.definition?.trim() || "",
      start_date: data.start_date || null,
    },
    { headers }
  );
  return response.data;
}
